import React, {useEffect, useState} from 'react';
import ReactApexChart from 'react-apexcharts';


function ApexChart({caseName}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch('/data/timeseries.json')
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error(error));
  }, [])

  if (!data) {
    return <div>Loading..</div>
  }

  // const fiterValue = 2;
  const sliceDay = -180;
  // categories: data[caseName]['dates'].filter((data, index) => index % fiterValue === 0),
  const options = {
      chart: {
        id: 'line',
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true,
        }
      },
      xaxis: {
        // categories: data[caseName]['dates'].filter((data, index) => index % fiterValue === 0),
        categories: data[caseName]['dates'].slice(sliceDay),
        tickAmount: 10 // ограничиваем количество точек на оси x до каждой 10-ой точки
      },
      yaxis: [
        {
          show: true,
          title: {
            text: 'Cost, Total Returns, and Predicted Cost',
          },
          seriesName: 'cost'
        }, {
          show: false,
          seriesName: 'cost',
        }, {
          show: false,
          seriesName: 'profitability_ratio'
        }, {
          show: false,
          seriesName: 'cost'
        },
      ]
    }
  ;

  const series = [
    {
      name: 'cost',
      data: data[caseName]['costs'].slice(sliceDay),
    },
    {
      name: 'total_returns',
      data: data[caseName]['total_returns'].slice(sliceDay),
    },
    {
      name: 'profitability_ratio',
      data: data[caseName]['profitability_ratio'].slice(sliceDay),
    }, {
      name: 'predict_cost',
      data: data[caseName]['predict_cost'].slice(sliceDay),
    },
  ];

  const styles = {
    container: {
      width: '100%',
      margin: 'auto',
      maxWidth: '95%',
    }
  }

  return (
    <div style={styles.container}>
      <ReactApexChart options={options} series={series} type="line" height={350}/>
    </div>
  );

}

export default ApexChart;
